// Pointer depth ([data-pointer-depth]): while a mouse moves over the element, --px and --py run from -1 to 1 with
// its position (0 in the middle) and glide back to 0 when it leaves; eased, so the layers that use them (the home
// hero's tilt and brand blocks, --pdx/--pdy in components/_motion.scss) float rather than jump. Touch input and
// reduced motion leave them at 0.
import { reducedMotion } from './motion.js'

const EASE = 0.08 // share of the remaining way per frame

export function initPointerDepth() {
	document.querySelectorAll('[data-pointer-depth]').forEach((element) => {
		const target = { x: 0, y: 0 }
		const current = { x: 0, y: 0 }
		let frame = 0

		const step = () => {
			current.x += (target.x - current.x) * EASE
			current.y += (target.y - current.y) * EASE
			const done = Math.abs(target.x - current.x) < 0.001 && Math.abs(target.y - current.y) < 0.001
			if (done) Object.assign(current, target)
			element.style.setProperty('--px', current.x.toFixed(4))
			element.style.setProperty('--py', current.y.toFixed(4))
			frame = done ? 0 : requestAnimationFrame(step)
		}
		const move = (x, y) => {
			target.x = x
			target.y = y
			if (!frame) frame = requestAnimationFrame(step)
		}

		element.addEventListener('pointermove', (event) => {
			if (event.pointerType !== 'mouse' || reducedMotion.matches) return
			const box = element.getBoundingClientRect()
			move(((event.clientX - box.left) / box.width) * 2 - 1, ((event.clientY - box.top) / box.height) * 2 - 1)
		})
		element.addEventListener('pointerleave', () => move(0, 0))
	})
}
